import { useState, useEffect, useRef } from "react";
import { Input, Typography, Flex, Alert } from "antd";
import CustomButton from "../../components/CustomButton/Button";
import { useSelector } from "react-redux";
import "./OtpContent.scss";
import { BTN_TXT, DESC_TXT } from "../../constants/constants";
import PrimaryButton from "../CustomButton/PrimaryButton";

const { Text } = Typography;

const numberOfDigits = 6;

const OtpContent = ({
    validateOtp,
    resendOtp,
    otpType,
    email,
    mobile
}) => {
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const otpBoxReference = useRef([]);
    const { otpData, editOtpData, otpError, validateOtpLoading,editOtpError } = useSelector((state) => state.business);

    const isOtpFilled = otp.every((digit) => digit !== "");

    useEffect(() => {
        setOtp(new Array(numberOfDigits).fill(""));
        setSeconds(60);
        setIsResendEnabled(false);
    }, []);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsResendEnabled(true);
        }
    }, [seconds]);

    const handleResendOtp = () => {
        setOtp(new Array(numberOfDigits).fill(""));
        setSeconds(60);
        setIsResendEnabled(false);
        resendOtp()
    };

    const handleChange = (value, index) => {
        let newArr = [...otp];
        newArr[index] = value;
        setOtp(newArr);

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleBackspaceAndEnter = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus();
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleVerifyOtp = async () => {
        const otpString = otp.join("");

        const payload = {
            email,
            otp: otpString,
            reqId: otpData?.reqId || editOtpData?.reqId,
            docId: otpData?.docId || editOtpData?.docId,
        }

        if (otpType === "phoneNumber") {
            delete payload.email
            payload.mobile = mobile
        }

        validateOtp(payload)

    };

    return (
        <div className="otp-content-container">
            <Text style={{ fontSize: 14, color: "#464646" }}>
                {`We’ve sent a One-Time Password (OTP) to your ${otpType === "email" ? `email ${email}` : `mobile number ${mobile}`} `}
            </Text>
            <Flex
                align="center"
                justify="space-between"
                style={{ marginTop: 30, width: "80%" }}
            >
                {otp.map((digit, index) => (
                    <Input
                        key={index}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                        ref={(reference) => (otpBoxReference.current[index] = reference)}
                        style={{ textAlign: "center", width: 50.6 }}
                        maxLength={1}
                    />
                ))}
            </Flex>
            {(otpError || editOtpError) && <Alert style={{ marginTop: 20 }} message={otpError?.message || otpError || editOtpError} type="error" showIcon />}
            <PrimaryButton
                block
                onClick={handleVerifyOtp}
                disabled={!isOtpFilled}
                loading={validateOtpLoading}
                className="otp-submit-btn"
            >
                {BTN_TXT.VERIFY_OTP}
            </PrimaryButton>

            {isResendEnabled ? (
                <Text onClick={handleResendOtp}>
                    Didn’t Received the Code? <CustomButton type="link">{BTN_TXT.RESEND}</CustomButton>
                </Text>
            ) : (
                <Text>
                    Resend available in {seconds} {seconds === 1 ? "second" : "seconds"}
                </Text>
            )}
            {otpType === "email" && (
                <Text style={{ color: "#40566D", marginTop: 20, fontSize: 12, textAlign: "center" }}>
                    {DESC_TXT.OTP_INFO_TEXT}
                </Text>
            )}
        </div>
    );
};

export default OtpContent;
